<template>
  <ui-dialog
    :show="isOpen"
    :closable="false"
    persistent
    scrollable
    max-width="623"
    @input="close"
  >
    <template #header>
      <h3>
        {{ $t("message.facilityCreate.dialog.facilityCreated.title") }}
      </h3>
      <p class="subtitle">
        {{
          $t("message.facilityCreate.dialog.facilityCreated.subtitle", {
            account,
            profile
          })
        }}
      </p>
      <p class="heading">
        {{
          $t("message.facilityCreate.dialog.facilityCreated.importedToCenter")
        }}
      </p>
    </template>
    <template #default>
      <p class="heading">
        {{
          $t(
            "message.facilityCreate.dialog.facilityCreated.verificationStarted"
          )
        }}
      </p>
    </template>
    <template #actions>
      <div class="d-flex justify-center w-100 mt-3">
        <ui-button
          color="primary"
          outlined
          class="mr-2"
          @click="goToFacilitiesList"
        >
          {{
            $t(
              "message.facilityCreate.dialog.facilityCreated.goToFacilitiesList"
            )
          }}
        </ui-button>
        <ui-button color="primary" class="ml-2" @click="createNew">
          {{ $t("message.facilityCreate.dialog.facilityCreated.createNew") }}
        </ui-button>
      </div>
    </template>
  </ui-dialog>
</template>

<script>
export default {
  name: "FacilityCreatedDialog",
  props: {
    isOpen: {
      type: Boolean,
      required: true
    },
    account: {
      type: String,
      required: true
    },
    profile: {
      type: String,
      required: true
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    createNew() {
      this.close();
      this.$emit("createNew");
    },
    goToFacilitiesList() {
      this.close();

      this.$router.push({
        name: "business-addresses-list"
      });
    }
  }
};
</script>

<style lang="scss" scoped>
h3,
.heading {
  @include font-size(22px);
  width: 100%;
  color: $text;
  line-height: 28px;
  font-weight: 600;
  text-align: center;
  margin-bottom: 0;
  margin-top: $spacing;
}

.subtitle {
  @include font-size(16px);
  width: 80%;
  margin: $spacing * 2 auto;
  font-weight: 500;
  text-align: center;
  line-height: 19px;
}
</style>
